/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import EditLeadModalNoteItem from './EditLeadModalNoteItem'
import { LeadNote } from 'types/entities/LeadNote'

interface EditLeadModalNotesListProps {
    notes: LeadNote[]
    onEdit: (note: LeadNote) => void
    onDelete: (note: LeadNote) => void
}

const EditLeadModalNotesList = (props: EditLeadModalNotesListProps) => {
    if (!props.notes.length) {
        return null
    }

    return (
        <>
            {props.notes.map((note) => (
                <EditLeadModalNoteItem
                    key={note.id}
                    note={note}
                    onEdit={props.onEdit}
                    onDelete={props.onDelete}
                />
            ))}
        </>
    )
}

export default EditLeadModalNotesList
